<style scoped>
    @import url("../../styles/smartControl/painelInitSC.scss");
</style>

<template>
    <div class="box_painelInitSC">

        <div class="boxTit">
            <span class="tit">Descrição</span>
        </div>

        <div class="boxContent">

            <div class="boxValue">

                <v-icon size="36" class="mr-2 elValue">mdi-clipboard</v-icon>

                <div class="elValue">{{ this.$store.state.prodSC }}</div>

            </div>

            <div class="boxValue">

                <v-icon size="36" class="mr-2 elValue">mdi-clipboard</v-icon>

                <div class="elValue">{{ this.$store.state.culturaSC }}</div>

            </div>

            <div class="boxValue">

                <v-icon size="36" class="mr-2 elValue">mdi-wrench-cog</v-icon>

                <div class="elValue">Atuadores: {{ qnt_atuadores }}</div>

            </div>

            <div class="boxValue">

                <v-icon size="36" class="mr-2 elValue">mdi-leak</v-icon>

                <div class="elValue">Sensores: {{ qnt_sensores }}</div>

            </div>

        </div>

    </div>
</template>

<script>
export default {

    props:['qntAtuadores','qntSensores'],

    data() {
        return {
            
            qnt_atuadores:0, // qnt pinos ativos
            qnt_sensores:0, // qnt params
        }
    },

    methods:{

        /*preInitS() {

            //let liS = this.$store.state.liSensoresSC
            let liS = this.liSensoresSC // via props | 20/10/2025
            //console.log('liS [tam]: ',liS.length)

            let c=0
            while (c < liS.length) {
                let liParams = liS[c]['params'] // lista de params do sensor
                let j=0
                while (j < liParams.length) {
                    this.qnt_sensores++
                    j++
                }
                c++
            }
        },

        preInitA() {

            //this.qnt_atuadores = this.$store.state.liAtuadoresSC.length
            //console.log('liA [tam]: ',this.$store.state.liAtuadoresSC.length)
            
            const liA = this.liAtuadoresSC // via props | 20/10/2025
            let c=0
            while (c < liA.length) {
                let liParams = liA[c]['params'] // lista de params do sensor
                let j=0
                while (j < liParams.length) {
                    if (liParams[j]['status'] == 'on') { this.qnt_atuadores++; }
                    j++
                }
                c++
            }
        },*/
    },

    created() {
        //
        //this.preInitS()
        //this.preInitA()

        // -- 23/10/2025 -- recebimento via props.
        this.qnt_atuadores = this.qntAtuadores
        this.qnt_sensores = this.qntSensores
    }
}
</script>